import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getMeetSanctionConfigurationData from './GetMeetSanctionConfigurationData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const MeetSanctionConfigurationData = {
  INITIAL_STATE,
  getMeetSanctionConfigurationData
};

export default MeetSanctionConfigurationData;